// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  checked: boolean
};

type ComposedProps = Props & WithI18nProps;

class CollectionHeader2 extends Component<ComposedProps> {
  render() {
    const { i18n, checked } = this.props;
    const CollectionHeaderClass = classnames('collection-header-item collection-header-item-2', {
      active: checked
    });

    return (
      <div className={CollectionHeaderClass}>
        <div className="collection-header-item__content">
          <p className="title">
            {i18n.translate('AdminHTML.ThemeSetting.LayoutModal.collectionHeader_TitleSample')}
          </p>
          <p className="description">
            {i18n.translate(
              'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample1'
            )}
            <br />
            {i18n.translate(
              'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample2'
            )}
          </p>
          <div className="overlay"></div>
        </div>
      </div>
    );
  }
}

export default withI18n()(CollectionHeader2);
